export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SECONDS = 10;
export const RESULTS_PER_PAGE = 10;
export const KEY = 'd5a738c3-edcd-4eed-98c8-cb5cd37395d1';
export const CLOSE_TIME_SEC = 2.5;
